"use strict";
var quote_sidebar_component_1 = require("./quote-sidebar.component");
exports.QuoteSidebarComponent = quote_sidebar_component_1.QuoteSidebarComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/coverage-cart/index.js